import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import CERTIFICATES_QUERY from '../queries/CERTIFICATES_QUERY';
import { getFormattedDate, getFormattedDateTime } from '../../utils';

const useCertificates = () => {
    const [ certificates, setCertificates ] = useState( [] );
    const { data, loading, error } = useQuery( CERTIFICATES_QUERY, { fetchPolicy: 'network-only' } );

    useEffect( () => {
        if ( loading || error || !data || !data.certificateTemplates?.edges ) { return; }
        
        try {
            const result = data.certificateTemplates.edges.map( i => { 
                return {
                    id: i.node.id || '',
                    key: i.node.id || '',
                    name: i.node.name || '',
                    createdAt: getFormattedDate( i.node.createdAt ),
                    createdAtFull: getFormattedDateTime( i.node.createdAt ),
                    updatedAt: getFormattedDate( i.node.updatedAt ),
                    updatedAtFull: getFormattedDateTime( i.node.updatedAt ),
                    brandId: i.node?.brand?.id || '',
                    brandName: i.node?.brand?.name || '',
                    preview: i.node?.certificateTemplateUrl || '', 
                    profileName: i.node?.certificateProfile.name || '',  
                }; 
            } );

            setCertificates( 
                result.sort( ( a, b ) => ( a.name?.toLowerCase() || '' ).localeCompare( ( b.name?.toLowerCase() || '' ) ) )
            );
        } catch ( error ) {
            console.error( 'Error parsing certificates', error ); 
            setCertificates( [] );
        }
    }, [ loading, error ] );
   
    return useMemo( () => {
        return {
            certificates,
            certificatesError: error,
            certificatesLoading: loading
        };
    }, [ certificates, error, loading ] );
};

export default useCertificates;
